// extracted by mini-css-extract-plugin
module.exports = {"link":"WearableCollection_link__2GxFi"};